function checkPasswordStrength(password = ""){
    let passwordStrength = {
        isValid : false,
        validation : {
            long : /(?=.{8,})/.test(password),
            uppercase : /(?=.*[A-Z])/.test(password),
            lowercase : /(?=.*[a-z])/.test(password),
            digit : /(?=.*[0-9])/.test(password),
            special : /([^A-Za-z0-9])/.test(password)
        }
    }

    passwordStrength.isValid = Object.values(passwordStrength.validation).every(validator=>validator);

    return passwordStrength;
}

export default checkPasswordStrength;